import { ChangeCell } from "@similarweb/pro-logic-components";

/**
 * Rank-delta value. Renders through `ChangeCell` so the up/down arrows and colors match the
 * rest of the app's change cells — only the value is formatted as an integer position delta
 * instead of a percentage. Positive means the site climbed.
 * Shared by the Rank Change table column and the Top movers widgets.
 */

interface IRankChangeValueProps {
    value: number;
}

export const RankChangeValue = ({ value }: IRankChangeValueProps) => (
    <ChangeCell
        value={value}
        formattedValue={String(Math.abs(value))}
    />
);

RankChangeValue.displayName = "RankChangeValue";
